export function mixInit (Vue) {
  Vue.prototype.cloneObj = function (obj) {
    let str, newObj = obj.constructor === Array ? [] : {};
    if (typeof obj !== 'object') {
      return;
    } else if (window.JSON) {
      str = JSON.stringify(obj),
        newObj = JSON.parse(str);
    } else {
      for (var i in obj) {
        newObj[i] = typeof obj[i] === 'object' ? this.cloneObj(obj[i]) : obj[i];
      }
    }
    return newObj;
  };
  Vue.prototype.formatHttpToHttps = function (url) {
    // console.log(9999, url)
    // console.log(3333, url.indexOf('http://newapp2-10000467.cos.ap-shanghai.myqcloud.com'))

    if (url) {
      let urlStr = url
      let proto = urlStr.split('://')[0]
      let others = urlStr.split('://')[1]
      if ((proto).trim() == 'http') {
        urlStr = 'https' + '://' + others
      }
      return urlStr
    } else {
      return url
    }
  }
}


// WEBPACK FOOTER //
// ./src/utils/mixInit.js